import * as React from 'react';
import { Switch } from '@cian/ui-kit/checkbox';
import { InlineText1 } from '@cian/ui-kit/typography';
import * as styles from './AutoProlong.mobile.css';

interface IAutoProlongMobileProps {
  value: boolean;
  isDisabled: boolean;
  onChange(): void;
}

export const AutoProlongMobile = ({ value, isDisabled, onChange }: IAutoProlongMobileProps) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['auto-prolong']}>
        <InlineText1 color={isDisabled ? 'black_40' : 'black_100'}>Автопродление публикации</InlineText1>
        <Switch checked={value} disabled={isDisabled} onChange={onChange} />
      </div>
    </div>
  );
};
